import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { LogoMark } from "./Ornaments";
import { POLICY_LINKS } from "@/lib/policies";
import { useLanguage } from "@/lib/i18n";
import "./SiteFooter.css";

const LEGAL_SAFETY_LINKS = [
  ...POLICY_LINKS.map((p) => ({ to: p.to, label: p.label, testId: `footer-${p.key.toLowerCase()}-link` })),
  { to: "/contact", label: "Contact Us", testId: "footer-contact-link" },
];

export const SiteFooter = () => {
  const { t } = useLanguage();

  return (
  <footer className="site-footer" data-testid="site-footer">
    <div className="site-footer-inner">
      <div className="site-footer-brand">
        <div className="site-footer-logo">
          <LogoMark size={34} />
          <span className="site-footer-wordmark">
            Suffa <em>Matrimony</em>
          </span>
        </div>
        <p className="site-footer-tagline">
          {t("A trusted Muslim matrimonial service — for serious and halal rishtas.")}
        </p>
        <p className="site-footer-rules" data-testid="footer-rules">
          {t(
            "Browse profiles for free. Profile registration fee: ₹500 one-time. If a marriage is successfully finalized through Suffa Matrimony, a Successful Match Service Fee of ₹5,000–₹10,000 applies separately to each side. The applicable fee will be communicated and agreed upon before payment.",
          )}
        </p>
      </div>

      <nav className="site-footer-col" aria-label="Legal & Safety">
        <h4>Legal &amp; Safety</h4>
        <ul>
          {LEGAL_SAFETY_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={l.testId}>
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="site-footer-col">
        <h4>Contact</h4>
        <a
          className="site-footer-contact"
          href="mailto:suffamatrimony@gmail.com"
          data-testid="footer-email-link"
        >
          <Mail size={15} aria-hidden="true" />
          suffamatrimony@gmail.com
        </a>
        <a
          className="site-footer-contact"
          href="tel:9924610588"
          data-testid="footer-phone-link"
        >
          <Phone size={15} aria-hidden="true" />
          9924610588
        </a>
      </div>
    </div>

    <div className="site-footer-bottom">
      <span>© {new Date().getFullYear()} Suffa Matrimony. All rights reserved.</span>
    </div>
  </footer>
  );
};

export default SiteFooter;
